<div class="channel-panel" *ngIf="channel">
  <div class="channel-panel__header">
    <div class="channel-panel__identity">
      <div class="channel-panel__icon">C</div>
      <div>
        <div class="channel-panel__name">{{ channel.name }}</div>
        <div class="channel-panel__sub">
          {{ channel.code }} · {{ channel.status }}
        </div>
      </div>
    </div>
    <button class="channel-panel__close">×</button>
  </div>

  <div class="channel-panel__section">
    <div class="channel-panel__label">SKU RULE IMPACT</div>
    <div class="channel-panel__muted">{{ channel.skuRuleImpact }}</div>
  </div>

  <div class="channel-panel__message">
    {{ channel.message }}
  </div>

  <div class="channel-panel__section">
    <div class="channel-panel__label">WHAT HAPPENS WHEN DEACTIVATED</div>

    <div class="channel-panel__rules">
      @for (rule of channel.deactivationRules; track rule.label) {
        <div class="channel-panel__rule">
          <span>{{ rule.label }}</span>
          <span
            class="channel-panel__tag"
            [class.channel-panel__tag--danger]="rule.type === 'danger'"
            [class.channel-panel__tag--success]="rule.type === 'success'"
          >
            {{ rule.state }}
          </span>
        </div>
      }
    </div>
  </div>

  <div class="channel-panel__section">
    <div class="channel-panel__label">CROSS-CHANNEL CHECK</div>

    <div class="channel-panel__stats">
      <div><span>Active POS</span><strong>{{ channel.activePos }}</strong></div>
      <div><span>Historical POS</span><strong>{{ channel.historicalPos }}</strong></div>
      <div><span>Created</span><strong>{{ channel.created }}</strong></div>
      <div><span>Last modified</span><strong>{{ channel.lastModified }}</strong></div>
    </div>
  </div>

  <button class="channel-panel__danger-button">Deactivate channel</button>
</div>